<template>
	<div class="header">
		<div class="header-left" v-if="isdetail">
			<span  @click="$router.go(-1)" class="link">
				<i class="el-icon-arrow-left"></i>{{ $route.meta.name }}
			</span>
		</div>
		<div class="header-left" v-else>
			<span>
				{{ $route.meta.name }}
			</span>
		</div>
	</div>
</template>

<script type="text/babel">
	export default {
		data(){
			return {

			}
		},
		computed:{
			isdetail(){
				const path = this.$route.path;
				return path.split('/')[2] != 'index'
			}
		}
	}
</script>

<style lang="less" rel="stylesheet/less">
	.header {
		border-bottom: 1px solid #ebeef5;
		height: 60px;
		line-height: 60px;
		background: #fff;
		padding: 0 20px;
		box-sizing: border-box;
	}
	.header-left{
		font-size: 16px;
		.link{
			cursor: pointer;
			&:hover{
				color: #056dff;
			}
		}
	}
</style>